module.exports = {
  donateLink: "https://www.buymeacoffee.com/fishbros",
  url: "https://thedrinking.games/",
  blackCards: "🂡🂢🂣🂤🂥🂦🂧🂨🂩🂪🂫🂭🂮🃑🃒🃓🃔🃕🃖🃗🃘🃙🃚🃛🃝🃞",
  redCards: "🂱🂲🂳🂴🂵🂶🂷🂸🂹🂺🂻🂽🂾🃁🃂🃃🃄🃅🃆🃇🃈🃉🃊🃋🃍🃎",
};
